import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const credituniondetailPageContext = React.createContext({});
export let credituniondetailPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMCreditUnionDetailGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  credituniondetailPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(credituniondetailPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    credituniondetailPageMachine,
    credituniondetailPageState: state,
    credituniondetailPageSend: send,
  };
};
